import React from 'react';
import { Loader } from 'freemium-ui';
import { isNil } from 'lodash';
import { useGetSegmentCount } from '../../hooks';

type SegmentContactsCountProps = {
  id: string;
};

const SegmentContactsCount = (props: SegmentContactsCountProps) => {
  const { id } = props;
  const {
    data,
    isLoading: isLoadingSegmentCount,
    isError: isSegmentCountError,
  } = useGetSegmentCount({
    segmentId: id,
    refetchOnWindowFocus: true,
  });

  return (
    <>
      {(isLoadingSegmentCount || isNil(data) || isNil(data.count)) &&
      !isSegmentCountError ? (
        <Loader size="small" />
      ) : (
        <>{isSegmentCountError ? '-' : data?.count}</>
      )}
    </>
  );
};

export default SegmentContactsCount;
